import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { getTranslation } from '@common/utils';

import { IFeedbackProps } from './types';

import * as s from './Feedback.scss';

const t = getTranslation('common.components.Feedback');

export const Feedback = ({
	title,
	classNames: {
		block: blockClassName,
		link: linkClassName,
	} = {},
}: IFeedbackProps) => {
	const {
		urls: {
			feedback: feedbackUrl,
		},
	} = getConfig();

	return (
		<span className={cn(s.block, blockClassName)}>
			<a
				className={cn(s.link, linkClassName)}
				href={feedbackUrl}
				target="_blank"
				rel="noopener noreferrer"
			>
				{title || t('title')}
			</a>
		</span>
	);
};
